import { useCallback } from 'react';
import { SongSlug } from '../../../common/src/model.ts';
import { useCurrentOrg } from './use_current_org.tsx';

/** Hides a song in Our Hymnal, or shows it again, by editing the current org's hidden songs. */
export function useSongVisibility(): {
  setSongVisibility: ({ songSlug, isVisible }: { songSlug: SongSlug; isVisible: boolean }) => Promise<void>;
} {
  const { currentOrg, updateOrgInfo } = useCurrentOrg();
  const setSongVisibility = useCallback(
    async ({ songSlug, isVisible }: { songSlug: SongSlug; isVisible: boolean }) => {
      if (!currentOrg) {
        console.error(`setSongVisibility: Missing org`);
        return;
      }
      let hiddenSongs: SongSlug[];
      if (isVisible) {
        hiddenSongs = currentOrg.hiddenSongs?.filter((currentSongSlug) => currentSongSlug !== songSlug) ?? [];
      } else {
        hiddenSongs = [...(currentOrg.hiddenSongs ?? []), songSlug];
      }
      await updateOrgInfo({ id: currentOrg.id, hiddenSongs });
    },
    [currentOrg, updateOrgInfo],
  );
  return { setSongVisibility };
}
